import React from "react";
import { Typography } from "@material-ui/core";
import { AlertCircleOutline } from "mdi-material-ui";

function SomethingWrong({ text = "Something went wrong" }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <AlertCircleOutline fontSize="large" />
      <Typography>{text}</Typography>
    </div>
  );
}

export default SomethingWrong;
